import { getStores, hasSDK } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { mentionChipClassName } from '@/features/mention/mention-chip';
import { cn } from '@/lib/utils';

import { useEnsureEntityReferenceLoaded } from './use-entity-reference';

import type { EntityReference } from '@littlebird/markdown-utils';

export const EntityReferenceChip = observer(
  ({
    reference,
    selected = false,
  }: {
    reference: EntityReference;
    selected?: boolean;
  }) => {
    useEnsureEntityReferenceLoaded(reference);

    const { entity, attributes } = reference;
    const id = attributes.id;
    const stores = hasSDK() ? getStores() : undefined;

    let title: string;
    let Icon: typeof Icons.chat;

    switch (entity) {
      case 'routine':
        title =
          stores?.routines.getByReferenceId(Number(id))?.title ||
          `Routine ${id}`;
        Icon = Icons.calendarClock;
        break;
      case 'chat':
        title = stores?.threads.data.get(id)?.title || 'Chat';
        Icon = Icons.chat;
        break;
      case 'meeting':
        title = stores?.meetings.data.get(id)?.name || 'Meeting';
        Icon = Icons.calendar;
        break;
      default:
        return reference.raw;
    }

    return (
      <span
        data-entity={entity}
        data-entity-id={id}
        title={title}
        className={cn(
          mentionChipClassName(selected),
          'max-w-full cursor-default'
        )}
      >
        <Icon className="size-4 shrink-0" />
        <span className="min-w-0 truncate">{title}</span>
      </span>
    );
  }
);
